<template>
  <div>
    <breadcrumbs></breadcrumbs>

    <div class="datd-abc">
      <div class="ind-title lh50 f16">
        <!-- <i class="el-icon-loading"></i> -->
        回收站信息
      </div>
    </div>

    <div class="a7">
      <div class="a1">
        <div>
          <img
            class="a1-img"
            src="../../assets/images/yhx1.png"
            alt=""
            srcset=""
          />
        </div>

        <div class="a4">
          <div class="a2">{{ arr.allCount }}</div>
          <div class="a3">回收站个数(个)</div>
        </div>
      </div>
    </div>
    <div class="con-let"></div>
    <!-- 查询条件 -->
    <el-form
      ref="searchForm"
      :model="searchForm"
      label-width="150px"
      inline
      class="demo-form-inline"
      size="small"
      style="border-bottom: 1px solid var(--table-border)"
    >
      <el-form-item label="状态">
        <el-select v-model="searchForm.state" placeholder="全部">
          <el-option label="启用" value="1"></el-option>
          <el-option label="禁用" value="2"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="输入搜索" prop="name">
        <el-input
          v-model="searchForm.keyword"
          placeholder="请输入回去收站名称/编号"
        ></el-input>
      </el-form-item>

      <el-form-item label="选择行政区域" prop="cityDetailId">
        <el-cascader
          :props="optionProps"
          v-model="regionId"
          :options="city"
          @change="cityDetailIdChange"
          clearable
        ></el-cascader>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="getchaoxu">查询</el-button>
        <el-button class="getchozi" @click="getchozhi">重置</el-button>
      </el-form-item>
    </el-form>
    <!-- 里面有编辑，新增按流-->
    <btns @exec="exec"></btns>

    <div class="x"></div>

    <el-table
      :data="tableData"
      style="width: 100%"
      :header-cell-style="{ background: '#eef1f6', color: '#606266' }"
      @selection-change="tableSelectionChange"
    >
      <el-table-column type="selection" width="70"> </el-table-column>
      <el-table-column label="编号" prop="backStopId"> </el-table-column>

      <el-table-column label="名称" prop="stopName"> </el-table-column>

      <el-table-column label="负责人" prop="contactName"> </el-table-column>

      <el-table-column label="手机号" prop="contactPhone"> </el-table-column>
      <el-table-column label="城市" prop="cityname"> </el-table-column>

      <el-table-column label="区域" prop="regionName"> </el-table-column>

      <el-table-column label="地址" prop="address"> </el-table-column>

      <el-table-column label="创建时间" prop="addtime"> </el-table-column>

      <el-table-column label="状态" prop="state">
        <template slot-scope="scope">
          <div v-if="scope.row.state == 1">启用</div>
          <div v-if="scope.row.state == 2">禁用</div>
        </template>
      </el-table-column>

      <el-table-column label="操作" prop="name" width="180">
        <template slot-scope="scope">
          <!-- <el-link type="primary" @click="adda">新增</el-link> -->
          <el-link
            style="margin: 0 20px"
            type="primary"
            @click="getbianji(scope.row)"
            >编辑</el-link
          >
          <el-link type="primary" @click="getchakanxq(scope.row.backStopId)"
            >查看详情</el-link
          >
        </template>
      </el-table-column>
    </el-table>

    <el-dialog
      title="回收站详情"
      :visible.sync="addORUpdateVisible1"
      width="500px"
      @close="gethqshzan"
    >
      <el-form label-width="100px" class="demo-ruleForm">
        <el-form-item label="名称">
          <el-input :disabled="true" v-model="rinme.stopName"></el-input>
        </el-form-item>

        <!-- <el-form-item label="回收站地址" >
               <el-input :disabled="true" v-model="xiangqingdz"></el-input>
        </el-form-item> -->

        <el-form-item label="工作日">
          <el-input :disabled="true" v-model="rinme.workDay"></el-input>
        </el-form-item>

        <el-form-item label="节假日">
          <el-input :disabled="true" v-model="rinme.offDay"></el-input>
        </el-form-item>

        <el-form-item label="负责人">
          <el-input :disabled="true" v-model="omm.name"></el-input>
        </el-form-item>

        <el-form-item label="手机号">
          <el-input :disabled="true" v-model="rinme.contactPhone"></el-input>
        </el-form-item>

        <el-form-item label="所属仓库">
          <el-select
            :disabled="true"
            v-model="rinme.houseId"
            placeholder="请选择"
          >
            <el-option
              v-for="item1 in saleList"
              :key="item1.houseId"
              :label="item1.houseName"
              :value="item1.houseId"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="所属业务员">
          <el-select
            :disabled="true"
            v-model="rinme.saleId"
            placeholder="请选择"
          >
            <el-option
              v-for="item1 in saleListbo"
              :key="item1.saleId"
              :label="item1.saleName"
              :value="item1.saleId"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="详情地址">
          <el-input :disabled="true" v-model="rinme.address"></el-input>
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-pagination
      class="mgt-10 pd-0"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="searlist.curPage"
      :page-sizes="[10, 20, 30, 50]"
      :page-size="searlist.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="totalCount"
    >
    </el-pagination>

    <el-dialog
      title="新增回收站"
      :visible.sync="addORUpdateVisible"
      width="500px"
    >
      <el-form
        :model="rinme"
        :rules="rules"
        ref="rinme"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-form-item label="名称" prop="stopName">
          <el-input v-model="rinme.stopName"></el-input>
        </el-form-item>
        <!-- 
         <el-form-item label="回收站地址" >
                <el-cascader :props="optionProps" v-model="regionId" :options="city" @change="handleChange" clearable></el-cascader>
        </el-form-item> -->

        <el-form-item label="工作日">
          <el-input v-model="rinme.workDay"></el-input>
        </el-form-item>

        <el-form-item label="节假日">
          <el-input v-model="rinme.offDay"></el-input>
        </el-form-item>

        <el-form-item label="负责人">
          <el-input v-model="rinme.name"></el-input>
        </el-form-item>

        <el-form-item label="手机号">
          <el-input v-model="rinme.phone"></el-input>
        </el-form-item>

        <el-form-item label="所属仓库">
          <el-select v-model="rinme.houseId" placeholder="请选择">
            <el-option
              v-for="item1 in saleList"
              :key="item1.houseId"
              :label="item1.houseName"
              :value="item1.houseId"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="所属业务员">
          <el-select v-model="rinme.saleId" placeholder="请选择">
            <el-option
              v-for="item1 in saleListbo"
              :key="item1.saleId"
              :label="item1.saleName"
              :value="item1.saleId"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="上传门店图">
          <el-upload
            class="avatar-uploader"
            action="https://cdb.dingningkeji.com/oss/uploadFile"
            :show-file-list="false"
            :on-success="handleAvatarSuccess"
            :before-upload="beforeAvatarUpload"
          >
            <img v-if="imageUrl" :src="imageUrl" class="avatar" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>

        <el-form-item label="详情地址">
          <!-- <amap :default-value="postForm.detailedAddress" @getPosition="getPosition" /> -->

          <!-- <maps @childFn="getaadd" ref="myClient"> </maps>  -->

          <!-- <mapa></mapa> -->

          <wraps @bMapDate="bMapDate"></wraps>
        </el-form-item>
      </el-form>

      <div class="shanc">
        <el-button @click="getoymd">取消</el-button>
        <el-button type="primary" @click="getxingaok">确定</el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="编辑回收站"
      :visible.sync="editORUpdateVisible"
      width="500px"
    >
      <el-form
        :model="editForm"
        label-width="100px"
        class="demo-ruleForm"
        :rules="rules"
        @close="geytguanbi"
      >
        <el-form-item label="名称">
          <el-input v-model="editForm.stopName"></el-input>
        </el-form-item>

        <!-- <el-form-item label="回收站地址"  v-if="dingxz2">
             
                <el-cascader :props="optionProps" v-model="regionId" :options="city" @change="bianji" clearable></el-cascader>
           
        </el-form-item> -->

        <!-- <el-form-item label="回收站地址"  v-if="dingzhixz" >
             
              <el-input v-model="shanyu" @focus="getxhuozxz"></el-input>
           
        </el-form-item> -->

        <el-form-item label="负责人">
          <el-input v-model="editForm.contactName"></el-input>
        </el-form-item>

        <el-form-item label="手机号">
          <el-input v-model="editForm.contactPhone"></el-input>
        </el-form-item>

        <el-form-item label="工作日">
          <el-input v-model="editForm.workDay"></el-input>
        </el-form-item>

        <el-form-item label="节假日">
          <el-input v-model="editForm.offDay"></el-input>
        </el-form-item>

        <el-form-item label="所属仓库">
          <el-select v-model="editForm.houseId" placeholder="请选择">
            <el-option
              v-for="item1 in saleList"
              :key="item1.houseId"
              :label="item1.houseName"
              :value="item1.houseId"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="所属业务员">
          <el-select v-model="editForm.saleId" placeholder="请选择">
            <el-option
              v-for="item1 in saleListbo"
              :key="item1.saleId"
              :label="item1.saleName"
              :value="item1.saleId"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="上传门店图">
          <el-upload
            class="avatar-uploader"
            action="https://cdb.dingningkeji.com/oss/uploadFile"
            :show-file-list="false"
            :on-success="handleAvatarSuccess"
            :before-upload="beforeAvatarUpload"
          >
            <img
              v-if="editForm.stopImg"
              :src="editForm.stopImg"
              class="avatar"
            />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>

        <el-form-item label="详情地址" v-if="xiangxzda1">
          <!-- <maps @childFn="gebianjid" ref="myClient"> </maps>  -->

          <wraps @bMapDate="bMapDatesid"></wraps>
        </el-form-item>

        <el-form-item label="详情地址" v-if="xiangqdz">
          <el-input v-model="editForm.address" @focus="getobbdsad"></el-input>
        </el-form-item>
      </el-form>

      <div class="shanc">
        <el-button @click.native="editORUpdateVisible = false">取消</el-button>
        <el-button type="primary" @click="eidthuishouzhan(editForm)"
          >确定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import options from "../../../city.json";
import btns from "@/components/btns.vue";
import breadcrumbs from "@/components/breadcrumbs.vue";

import maps from "@/components/maps.vue";

import mapa from "@/components/map.vue";

import amap from "@/components/amap";
import Wraps from "../../components/wraps.vue";
// import map from '../../components/map.vue';

export default {
  components: {
    amap,
    btns,
    maps,
    breadcrumbs,
    mapa,
    Wraps,
  },

  data() {
    var telValidate = (rule, value, callback) => {
      if (value != null && value != "") {
        var tel = /^0\d{2,3}-?\d{7,8}$/;
        var phone = /^1[13456789]\d{9}$/;
        if (value.length == 11) {
          //手机号码
          if (phone.test(value)) {
            // console.log(value);
            callback();
          }
        } else if (value.length == 13 && value.indexOf("-") != -1) {
          //电话号码
          if (tel.test(value)) {
            // console.log(value);
            callback();
          }
        }
        callback("请输入正确的电话号码！");
      } else {
        callback();
      }
    };

    return {
      //  postForm: {
      //   detailedAddress: '',
      //   longitude: '',
      //   latitude: ''
      // },
      ids: [],
      backStopId: "",

      xiangxzda1: false,
      xiangqdz: true,

      dingzhixz: true,
      dingxz2: false,
      shanyu: "",
      xiangqingdz: "",
      omm: "",
      editForm: {
        address: "",
        cityDetailId: "",

        cityId: "",
        houseId: "",
        lat: "",

        lon: "",

        name: "",

        phone: "",

        saleId: "",

        stopImg: "",

        workDay: "",

        offDay: "",

        stopName: "",
      },
      editORUpdateVisible: false,
      optionProps: {
        value: "regionId",
        label: "regionName",
        children: "child",
      },
      regionId: "",
      cityId: "",
      city: [],
      saleList: [],
      shaywy: "",
      saleListbo: [],
      abcd: {},
      houseId: "",
      rinme: {
        address: "",
        cityDetailId: "",

        cityId: "",
        houseId: "",
        lat: "",

        lon: "",

        name: "",

        phone: "",

        saleId: "",

        stopImg: "",

        workDay: "",

        offDay: "",

        stopName: "",
      },

      searlist: {
        curPage: 1,
        pageSize: 10,
      },
      totalCount: 0,
      addORUpdateVisible1: false,
      imageUrl: "",

      options: [],

      addORUpdateVisible: false,
      tableData: [],
      shanghai: "",
      tableSelection: [],
      
      beijing: "",
      arr: "",
      searchForm: {
        state: "",
      keyword: "",
      cityDetailId: "",
      },
      rules: {
        stopName: [
          { required: true, message: "请输入回收站名称", trigger: "blur" },
        ],
        address: [
          { required: true, message: "请输入回收站地址", trigger: "blur" },
        ],
        name: [
          { required: true, message: "请输入负责人姓名", trigger: "blur" },
        ],

        // "phone": [
        //   { required: true, message: '请输入手机号', trigger: 'blur' },
        //    { validator: telValidate, trigger: 'blur' }
        // ],
        houseId: [
          { required: true, message: "请输入所属仓库", trigger: "blur" },
        ],
        saleId: [{ required: true, message: "请输入业务员", trigger: "blur" }],
        stopImg: [
          { required: true, message: "请选择门店图片", trigger: "change" },
          // { validator: allNumValidate, trigger: 'blur' }
        ],
        // "phone": [
        //   { required: true, message: '请输入手机号', trigger: 'blur' },
        // ],
      },
    };
  },

  created() {
    // console.log("12345");
    this.city = options;
    this.getBackStopCount();
    this.getmeibiaod();
    this.getBackStopList(this.searlist.curPage, this.searlist.pageSize);
  },

  methods: {
    cityDetailIdChange(value) {
      if (value.length != 0) {
        this.searchForm.cityDetailId = this.regionId[2];
      } else {
        this.searchForm.cityDetailId = [];
      }
    },

    getoymd() {
      console.log("124");
      this.addORUpdateVisible = false;
      //  this.postForm=[]
    },

    bMapDatesid(o, a, data) {
      this.getdaaf(o, a);
      //  let searchValue=localStorage.getItem('searchValue')

      //  this.editForm.address=searchValue
      this.editForm.lon = o;
      this.editForm.lat = a;
      console.log(o, a, data, "55555555");
    },

    getdaaf(o, a) {
      this.$api.activitymsg
        .getLocation({
          lat: a,
          lng: o,
        })
        .then((e) => {
          this.editForm.address = e.regeocode.formatted_address;

          this.editForm.cityDetailId = e.regeocode.addressComponent.adcode;

          this.editForm.cityId =
            e.regeocode.addressComponent.adcode.substring(0, 4) + "00";

          console.log(
            e,
            e.regeocode.formatted_address,
            this.editForm.cityId,
            this.editForm.cityDetailId,
            "8888888"
          );
        });
    },

    getLocation(o, a) {
      this.$api.activitymsg
        .getLocation({
          lat: a,
          lng: o,
        })
        .then((e) => {
          this.rinme.address = e.regeocode.formatted_address;

          this.rinme.cityId =
            e.regeocode.addressComponent.adcode.substring(0, 4) + "00";

          this.rinme.cityDetailId = e.regeocode.addressComponent.adcode;

          console.log(
            e,
            e.regeocode.formatted_address,
            this.rinme.cityDetailId,
            this.rinme.cityId,
            "777777"
          );
        });
    },

    bMapDate(o, a, data) {
      this.getLocation(o, a);

      this.rinme.lon = o;
      this.rinme.lat = a;

      console.log(o, a, data);
    },

    // 获取地址信息
    // getPosition({ address, lat, lng, name }) {

    //  console.log(address,lat,lng,name);

    //   this.postForm.detailedAddress = address;
    //   this.postForm.longitude = String(lng);
    //   this.postForm.latitude = String(lat);

    // this.rinme.address=this.postForm.detailedAddress
    // this.rinme.lon= this.postForm.longitude
    // this.rinme.lat=this.postForm.latitude
    // },

    getobbdsad() {
      (this.xiangxzda1 = true), (this.xiangqdz = false);
    },

    getxhuozxz() {
      (this.dingzhixz = false), (this.dingxz2 = true);
    },

    geytguanbi() {
      (this.regionId = []),
        // this.$refs.myClient.searchVal='';
        (this.editORUpdateVisible = false);

      (this.xiangxzda1 = false),
        (this.xiangqdz = true),
        (this.dingzhixz = true),
        (this.dingxz2 = false);
    },

    eidthuishouzhan() {
      this.editForm.phone = this.editForm.contactPhone;

      this.editForm.name = this.editForm.contactName;

      // console.log(this.editForm);
      this.$api.activitymsg.editBackStop(this.editForm).then((e) => {
        this.editORUpdateVisible = false;
        (this.regionId = []),
          // this.$refs.myClient.searchVal='';

          (this.xiangxzda1 = false),
          (this.xiangqdz = true),
          (this.dingzhixz = true),
          (this.dingxz2 = false);
      });
    },

    gethqshzan() {
      this.rinme = {};
    },

    getchozhi() {
      this.searchForm={},
      this.regionId = "";
        this.getBackStopList(this.searlist.curPage, this.searlist.pageSize);
    },

    // 编辑

    getbianji(row) {
      //  _this.$refs.myClient.searchVal="123"

      this.editForm = row;

      var a = [];
      this.city.map((item1) => {
        item1.child.map((item2) => {
          // console.log( this.city,e.data.info.cityid);
          if (item2.regionId == this.editForm.cityid) {
            a.push(item2.regionName);
          }

          item2.child.map((item3) => {
            if (item3.regionId == this.editForm.cityDetailId) {
              a.push(item3.regionName);
            }
          });
        });
      });

      this.shanyu = a.join(",");

      console.log(row, 123);

      this.editORUpdateVisible = true;

      console.log(this, 9431);
    },

    //     update(){
    //       console.log("进入编辑")
    //       if (this.tableSelection.length != 1) {
    //         this.$message.error('请选中一行数据');
    //         return
    //       }
    //       this.editForm = this.tableSelection[0];
    //       console.log(this,"000")
    // //this.tableSelection[0].content;
    //        //this.$refs.mychild.searchVal("searchVal",this.tableSelection[0].content);
    //       // this.editForm.comment = this.tableSelection[0].content;
    //       console.log(this.tableSelection[0].address);
    //       this.editORUpdateVisible = true;

    //     },

    getxingaok() {
      this.$api.activitymsg.addBackStop(this.rinme).then((e) => {
        if (e.code == 200) {
          (this.regionId = []),
            //  this.postForm=[]
            (this.rinme = {}),
            (this.imageUrl = ""),
            // this.$refs.myClient.searchVal='';

            //  console.log( this.$refs.myClient.searchVal,123);

            this.$message({
              message: "添加成功",
              type: "success",
            });

          this.addORUpdateVisible = false;
          this.getBackStopCount();
          this.getBackStopList(this.searlist.curPage, this.searlist.pageSize);
        } else {
          this.$message.error(e.msg);
        }
      });
    },

    getaadd(data, vad) {
      console.log(data, "123", data.location);

      console.log(data.location.lng, data.location.lat, "进度");

      this.rinme.address = data.address;
      this.rinme.lon = data.location.lng;
      this.rinme.lat = data.location.lat;
    },

    handleChange(value) {
      console.log(value);

      this.rinme.cityId = value[1];
      this.rinme.cityDetailId = value[2];
    },

    gebianjid(data, vad) {
      console.log(data, "123");

      this.editForm.address = data.address;
      this.editForm.lon = data.location.lng;
      this.editForm.lat = data.location.lat;
    },

    bianji(value) {
      console.log(value);

      this.editForm.cityId = value[1];
      this.editForm.cityDetailId = value[2];
    },

    //       handleChange(value) {
    //          console.log(value);

    //        this.rinme.cityId=value[1]
    //       this.rinme.cityDetailId=value[2]

    //     },

    getmeibiaod() {
      this.$api.activitymsg.getAddBackStopForm({}).then((e) => {
        this.saleList = e.data.houseList;

        this.saleListbo = e.data.saleList;
      });
    },

    getchaoxu() {
      this.getBackStopList(this.searlist.curPage, this.searlist.pageSize);
    },

    getchozi() {
      (this.searchForm.keyword = ""),
        (this.searchForm.state = ""),
        (this.searchForm.cityDetailId = ""),
        this.getBackStopList(this.searlist.curPage, this.searlist.pageSize);
    },

    //  启用
    cing() {
      // if (this.tableSelection.length != 1) {
      //   this.$message.error("请选中一行数据");
      //   return;
      // }

      // let backStopId = this.tableSelection[0].backStopId;
      this.$confirm("确认要启用, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$api.activitymsg
          .updateStatus({
            backStopId: this.ids,
            status: 1,
          })
          .then((e) => {
            if (e.code == 200) {
              this.$message({
                message: "启用成功",
                type: "success",
              });

              this.getBackStopList(
                this.searlist.curPage,
                this.searlist.pageSize
              );
            } else {
              this.$message.error(e.msg);
            }
          })
          .catch(() => {
            this.$message.info("已取消启用");
          });
      });
    },

    // 禁用

    jingyong() {
      //  if (this.tableSelection.length != 1) {
      //     this.$message.error("请选中一行数据");
      //     return;
      //   }

      //   let backStopId = this.tableSelection[0].backStopId;

      this.$confirm("确认禁用, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })

        .then(() => {
          // console.log(backStopId,123);

          this.$api.activitymsg
            .updateStatus({
              backStopId: this.ids,
              status: 2,
            })
            .then((e) => {
              if (e.code == 200) {
                this.$message({
                  message: "禁用成功",
                  type: "success",
                });

                this.getBackStopList(
                  this.searlist.curPage,
                  this.searlist.pageSize
                );
              } else {
                this.$message.error(e.msg);
              }
            });
        })
        .catch(() => {
          this.$message.info("已取消启用");
        });
    },

    tableSelectionChange(val) {
      this.tableSelection = val;
      let backStopId = "";
      this.ids = this.tableSelection.map((item) => item.backStopId).join();

      // console.log("this.ids=============" + this.ids);
    },

    add() {
      this.addORUpdateVisible = true;
    },

    handleSizeChange(v) {
      this.searlist.pageSize = v;
      this.getBackStopList(this.searlist.curPage, v);
    },
    handleCurrentChange(v) {
      this.searlist.curPage = v;

      this.getBackStopList(v, this.searlist.pageSize);
    },

    getBackStopList(curr, pagesize) {
      this.$api.activitymsg
        .getBackStopList({
          current: curr,
          size: pagesize,
          keyword: this.searchForm.keyword,
          state: this.searchForm.state,
          cityDetailId: this.searchForm.cityDetailId,
        })
        .then((e) => {
          this.tableData = e.data;
          this.totalCount = e.totalCount;
        });
    },

    getBackStopCount() {
      this.$api.activitymsg.getBackStopCount({}).then((e) => {
        this.arr = e.data;
      });
    },

    // 详情
    getchakanxq(id) {
      this.$api.activitymsg
        .getBackStopInfo({
          backStopId: id,
        })
        .then((e) => {
          console.log(e);

          var a = [];
          this.city.map((item1) => {
            item1.child.map((item2) => {
              // console.log( this.city,e.data.info.cityid);
              if (item2.regionId == e.data.info.cityid) {
                a.push(item2.regionName);
              }

              item2.child.map((item3) => {
                if (item3.regionId == e.data.info.cityDetailId) {
                  a.push(item3.regionName);
                }
              });
            });
          });

          console.log(a, e.data.info.cityid);

          this.xiangqingdz = a.join(",");

          this.rinme = e.data.info;
          this.omm = e.data;
        });

      this.addORUpdateVisible1 = true;
    },

    handleAvatarSuccess(res, file) {
      this.imageUrl = URL.createObjectURL(file.raw);

      this.rinme.stopImg = res;

      this.editForm.stopImg = res;

      console.log(res, file);
    },
    beforeAvatarUpload(file) {
      console.log(file);
      // const isJPG = file.type === "image/jpeg";
      // const isLt2M = file.size / 1024 / 1024 < 2;

      // if (!isJPG) {
      //   this.$message.error("上传头像图片只能是 JPG 格式!");
      // }
      // if (!isLt2M) {
      //   this.$message.error("上传头像图片大小不能超过 2MB!");
      // }
      // return isJPG && isLt2M;
    },

    exec(fun) {
      if (this[fun]) {
        this.funTit = fun;
        this[fun]();
      } else {
        this.$message.error("方法未定义");
      }
    },

    getchakxq() {
      this.$router.push("orderitem");
    },
  },
};
</script>

<style scoped>
.x {
  height: 20px;
}

.con-let {
  height: 50px;
}

.a7 {
  width: 700px;
  display: flex;
  justify-content: space-between;
}

.a4 {
  margin-left: 20px;
}

.a3 {
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;

  color: var(--text-main);
  opacity: 1;
}

.shanc {
  display: flex;
  justify-content: center;
  align-items: center;
}

.a2 {
  font-size: 30px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: var(--text-main);
  opacity: 1;
}

.a1-img {
  width: 100px;
  height: 100px;
}
.avatar {
  width: 100px;
  height: 100px;
}
.a1 {
  width: 260px;
  height: 127px;
  opacity: 1;
  border-radius: 10px;
  border: solid 1px var(--table-border);
  display: flex;
  align-items: center;
  padding: 0 20px;
}
</style>
